import React from 'react';
import { Sparkles, X, RefreshCcw } from 'lucide-react';

export interface AiAnalysisModalProps {
  isAIPanelOpen: boolean;
  setIsAIPanelOpen: (val: boolean) => void;
  uiHiddenLevel: number;
  isAiLoading: boolean;
  aiAnalysis: string | null;
  requestAiAnalysis: () => void;
  processedData: any[];
}

export const AiAnalysisModal: React.FC<AiAnalysisModalProps> = ({
  isAIPanelOpen,
  setIsAIPanelOpen,
  uiHiddenLevel,
  isAiLoading,
  aiAnalysis,
  requestAiAnalysis,
  processedData,
}) => {
  if (!isAIPanelOpen || uiHiddenLevel === 2) return null;

  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-all duration-300 pointer-events-auto"
      onClick={() => setIsAIPanelOpen(false)}
    >
      <div 
        className="bg-[#080514]/95 backdrop-blur-3xl border border-[#cc00ff]/30 p-5 md:p-6 rounded-2xl w-full max-w-[500px] max-h-[85vh] flex flex-col transition-all duration-300 shadow-[0_0_50px_rgba(204,0,255,0.15)]"
        onPointerDown={(e) => e.stopPropagation()}
        onPointerUp={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4 pb-4 border-b border-[#cc00ff]/20 shrink-0">
          <h2 className="text-[14px] font-bold uppercase tracking-[3px] text-[#cc00ff] flex items-center gap-3">
             <Sparkles size={18} /> Dimensões I.A. 
          </h2>
          <button onClick={() => setIsAIPanelOpen(false)} className="text-[#cc00ff] p-1.5 bg-[#cc00ff]/10 rounded-full hover:bg-[#cc00ff]/20 transition-all">
            <X size={18} />
          </button>
        </div>
        
        <div className="flex-1 overflow-y-auto custom-scrollbar pr-2 mb-4">
           {isAiLoading ? (
             <div className="flex flex-col items-center justify-center py-10 space-y-4">
                <div className="w-8 h-8 border-2 border-[#cc00ff]/30 border-t-[#cc00ff] rounded-full animate-spin"></div>
                <p className="text-[11px] text-[#cc00ff]/80 font-mono tracking-widest uppercase animate-pulse">
                  Analisando o fractal...
                </p>
             </div>
           ) : aiAnalysis ? (
             <div className="text-[13px] text-white/80 leading-[1.8] space-y-4 text-justify font-sans tracking-wide pt-2">
                {aiAnalysis.split('\n\n').map((paragraph, index) => {
                   const parts = paragraph.split(/(\*\*.*?\*\*)/g);
                   return (
                     <p key={index} className="pb-1">
                       {parts.map((part, i) => {
                         if (part.startsWith('**') && part.endsWith('**')) {
                           return <strong key={i} className="text-white font-bold tracking-wider">{part.slice(2, -2)}</strong>;
                         }
                         return part;
                       })}
                     </p>
                   );
                })}
             </div>
           ) : (
             <div className="text-center py-10 text-white/50 text-[12px]">
               Nenhuma análise disponível.
             </div>
           )}
        </div>

        <div className="pt-4 border-t border-[#cc00ff]/20 shrink-0 flex justify-between items-center">
           <span className="text-[9px] uppercase tracking-[2px] text-[#cc00ff]/40 font-mono">
              Powered by Gemini
           </span>
           <button 
             onClick={() => requestAiAnalysis()}
             disabled={isAiLoading || processedData.length === 0}
             className="flex items-center gap-2 px-4 py-2 bg-[#cc00ff]/10 text-[#cc00ff] hover:bg-[#cc00ff]/20 border border-[#cc00ff]/30 rounded-lg text-[10px] font-bold uppercase tracking-[1px] transition-all disabled:opacity-50"
           >
             <RefreshCcw size={12} className={isAiLoading ? 'animate-spin' : ''} />
             Atualizar Leitura
           </button>
        </div>
      </div>
    </div>
  );
};
